// removed by extract-text-webpack-plugin
module.exports = {"root":"ToolboxSection__root___dRvIs","header":"ToolboxSection__header___1AXt-","body":"ToolboxSection__body___3UCAA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/ToolboxSection/ToolboxSection.scss
// module id = 997
// module chunks = 0